import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { Carousel } from "primereact/carousel";
import { Toast } from "primereact/toast";
import PrimaryButton from "../../shared/components/CustomButtons";
import CustomImage from "../../shared/components/CustomImage";
import CustomCard from "../../shared/components/CustomCard";
import Footer from "../../layout/Footer";
import { getImageUrl } from "../../utils/commonFunctions";
import Img1 from "../../assets/images/2.png";
import Img2 from "../../assets/images/4.png";
import Img3 from "../../assets/images/afterimg.webp";
import {
  fetchServices,
  fetchServiceBySlug,
} from "../../store/slices/servicesSlice";
import { Accordion, AccordionTab } from "primereact/accordion";
import EnquiryModal from "../../shared/Modals/EnquiryModal";
import FrequentQuestions from "./FrequentQuestions";

export default function ThreeDRender() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const toast = useRef(null);
  const [visible, setVisible] = useState(false);
  const { serviceDetails } = useSelector((state) => state.service);

  useEffect(() => {
    if (id) {
      dispatch(fetchServiceBySlug(id));
      dispatch(fetchServices());
    }
  }, [id, dispatch]);

  const HowItsWork = [
    {
      iconclass: "bg-red",
      order: "1",
      title: "Choose a Style",
      detail:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    },
    {
      iconclass: "bg-green",
      order: "2",
      title: "Upload photos",
      detail:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    },
    {
      iconclass: "bg-green",
      order: "3",
      title: "Get them delivered",
      detail:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    },
  ];

  const responsiveOptions = [
    { breakpoint: "1400px", numVisible: 1, numScroll: 1 },
    { breakpoint: "1199px", numVisible: 1, numScroll: 1 },
    { breakpoint: "767px", numVisible: 1, numScroll: 1 },
    { breakpoint: "575px", numVisible: 1, numScroll: 1 },
  ];

  const product = [{ image: Img1 }, { image: Img2 }, { image: Img3 }];

  // useEffect(() => {
  //   if (id) {
  //     dispatch(fetchServiceBySlug(id));
  //     dispatch(fetchServices());
  //   }
  // }, [id, dispatch]);

  const productTemplate = (product) => (
    <img
      src={product.image}
      alt={product.name}
      className="w-full border-round-xl shadow-2"
      style={{ height: "600px" }}
    />
  );

  return (
    <>
      <Toast ref={toast} />
      <div className="py-7">
        <div className="container">
          <div className="grid align-items-center">
            <div className="col-12 lg:col-5 p-4">
              <h2 className="heading text-5xl font-semibold">
                {serviceDetails?.serviceName}
              </h2>
              <p className="text-gray-color line-height-2 text-lg font-normal">
                {serviceDetails?.description}
              </p>
              <ul className="p-0 mb-4">
                {serviceDetails?.features?.length > 0 &&
                  serviceDetails.features.map((feature, index) => (
                    <li
                      key={index}
                      className="flex gap-3 align-items-center mb-3"
                    >
                      <i className="pi pi-check"></i>
                      <span className="text-gray-color">
                        {feature?.description}
                      </span>
                    </li>
                  ))}
              </ul>
              <PrimaryButton
                label="Enquire Now"
                extraClassNames="w-auto px-6"
                onClick={() => setVisible(true)}
              />
            </div>
            <div className="col-12 lg:col-7">
              <CustomImage
                src={serviceDetails?.primarySingleImage}
                className="w-full h-30rem border-round-xl"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="py-7 bg-light-primary">
        <div className="container">
          <h2 className="text-4xl heading rubik font-semibold">
            {serviceDetails?.about?.title}
          </h2>
          <p className="text-gray-color line-height-3">
            {serviceDetails?.about?.description}
          </p>
        </div>
      </div>
      <div className="py-7">
        <div className="container">
          <h2 className="heading text-center text-4xl mb-4 rubik">
            {serviceDetails?.benefitsTitle}
          </h2>
          <div className="grid bg-white mt-7">
            {serviceDetails?.benefits?.map((item, index) => (
              <div key={index} className="lg:col-4">
                <CustomCard
                  extraClass="text-center benefit-card lg:text-left shadow-3 h-full"
                  src={getImageUrl(item.iconImage)}
                  title={item.title}
                  detail={item.description}
                  width={40}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="py-7">
        <div className="container">
          <h2 className="heading text-center text-4xl mb-4 rubik">
            How does it work?
          </h2>
          <p className="text-gray-color text-center text-lg">
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry.
          </p>
          <div className="grid bg-white mt-7">
            {HowItsWork.map((item, index) => (
              <div key={index} className="col-12 lg:col-4">
                <CustomCard
                  iconClass={item.iconclass}
                  order={item.order}
                  title={item.title}
                  detail={item.detail}
                  extraClass="border-400 how-its-work border-round-xl border-1"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="py-7 bg-light-primary">
        <div className="container">
          <div className="grid justify-content-center">
            <div className="col-12 md:col-12">
              <h2 className="text-4xl text-center heading rubik font-semibold">
                3D Interior Rendering
              </h2>
              <p className="text-gray-color line-height-3 text-center text-lg">
                3D interior rendering serves as a powerful tool that designers
                use to convey design concepts and eye-catching visuals for
                pre-selling real estate.
              </p>
              <Carousel
                value={product}
                numVisible={1}
                className="photo-slider"
                numScroll={1}
                responsiveOptions={responsiveOptions}
                itemTemplate={productTemplate}
              />
              <div className="text-center mt-4">
                <PrimaryButton
                  label="Enquire Now"
                  extraClassNames="w-auto px-6"
                  onClick={() => setVisible(true)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <EnquiryModal
        visible={visible}
        setVisible={setVisible}
      />
      {/* faq start */}
      <FrequentQuestions />
      {/* <div className="py-7 bg-gray-light">
        <div className="container">
          <h2 className="heading text-center text-4xl mb-4 rubik">
            Frequently asked questions 
          </h2>
          <p className="text-gray-color text-center text-lg mb-7">
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry.
          </p>
          <Accordion
            className="w-full lg:w-8 m-auto faq-container"
            activeIndex={0}
            collapseIcon="pi pi-minus"
            expandIcon="pi pi-plus"
          >
            <AccordionTab header="Lorem Ipsum is simply dummy text?">
              <p className="m-0">
                Yes, you can try us for free for 30 days. If you want, we’ll
                provide you with a free, personalized 30-minute onboarding call
                to get you up and running as soon as possible.
              </p>
            </AccordionTab>
            <AccordionTab header="Lorem Ipsum is simply dummy text?">
              <p className="m-0">
                Yes, you can try us for free for 30 days. If you want, we’ll
                provide you with a free, personalized 30-minute onboarding call
                to get you up and running as soon as possible.
              </p>
            </AccordionTab>
            <AccordionTab header="Lorem Ipsum is simply dummy text?">
              <p className="m-0">
                Yes, you can try us for free for 30 days. If you want, we’ll
                provide you with a free, personalized 30-minute onboarding call
                to get you up and running as soon as possible.
              </p>
            </AccordionTab>
          </Accordion>
        </div>
      </div> */}
      {/* faq end */}
      <Footer />
    </>
  );
}
